import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getNetworksData } from 'modules/api/lookups';
import { cancelFunctions } from 'utils/cancelFunctions';
import { changeFormParams } from 'store/dealManagement/reducer';
import { changeNetworkReferenceData } from 'store/userOptions/reducer';
import { NetworkReferenceResponse } from 'store/userOptions/reducer.types';
import { DirectSalesMediaType } from 'components/common/types/DirectSalesCampaign.types';
import { AssetTypes } from 'components/common/types/AssetList.types';
import { getMarketId } from 'store/publisher/selectors';
import { LoadReferenceDataOptions } from './UseReferenceData.types';

const useNetworkReferenceData = ({
  environments,
  mediaType,
  startDate,
  endDate,
  isProductTemplate,
}: LoadReferenceDataOptions): void => {
  const dispatch = useDispatch();
  const market = useSelector(getMarketId);

  useEffect(() => {
    const loadNetworkReferenceData = async (): Promise<void> => {
      if ((!environments?.length || !mediaType || !startDate || !endDate) && !isProductTemplate) return;

      if ((isProductTemplate && !environments?.length) || !mediaType) return;

      dispatch(changeFormParams({ isFetchingNetworks: true }));

      const mandatoryPayloadData = {
        market,
        assetTypes: [mediaType === DirectSalesMediaType.PAPER ? AssetTypes.STATIC : mediaType],
        channelCodes: environments?.map(({ code }) => code),
      };

      try {
        const { networkGroup }: { networkGroup: NetworkReferenceResponse[] } = await getNetworksData(
          cancelFunctions,
          isProductTemplate
            ? mandatoryPayloadData
            : {
                ...mandatoryPayloadData,
                startDate,
                endDate,
              },
        );

        dispatch(changeNetworkReferenceData(networkGroup));
        // eslint-disable-next-line no-empty
      } catch {
      } finally {
        dispatch(changeFormParams({ isFetchingNetworks: false }));
      }
    };

    loadNetworkReferenceData();
  }, [environments, mediaType, startDate, endDate]);
};

export default useNetworkReferenceData;
